"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var Template=function(e){this.token=e};exports.Template=Template;